@let canLinkRisks = (canLinkRisks$ | async) === true;
@if (state$ | async; as state) {
    @switch (state.status) {
        @case ("loading") {
            <p role="status">{{ "linkedItems.loading" | t }}</p>
        }
        @case ("error") {
            <p role="alert">{{ "linkedItems.loadError" | t }}</p>
            <cerrix-button
                buttonType="secondary"
                [text]="'linkedItems.retry' | t"
                (click)="loadRisks()"
            />
        }
        @case ("loaded") {
            <app-linked-risk-row #riskTemplates (confidentialRowClick)="onConfidentialRiskClicked()" />
            <app-cerrix-linked-item-table
                [title]="'linkedItems.risks.risksTitle' | t: {} : translationScope"
                [items]="state.items"
                [templates]="riskTemplates"
                [loadDetails]="loadRiskDetails"
                [canLink]="canLinkRisks"
                [unlinkConfirmation]="{
                    title: 'linkedItems.risks.unlinkDialogTitle' | t,
                    description: 'linkedItems.risks.unlinkDialogDescription' | t
                }"
                (linkItems)="onLinkRisks(state.items)"
                (openItem)="onOpenLinkedRisk($event)"
                (unlinkItem)="onUnlinkRisk($event)"
            />
        }
    }
}
@let canLinkControls = (canLinkControls$ | async) === true;
@if (controlsState$ | async; as controlsState) {
    @switch (controlsState.status) {
        @case ("loading") {
            <p role="status">{{ "linkedItems.loading" | t }}</p>
        }
        @case ("error") {
            <p role="alert">{{ "linkedItems.loadError" | t }}</p>
            <cerrix-button
                buttonType="secondary"
                [text]="'linkedItems.retry' | t"
                (click)="loadControls()"
            />
        }
        @case ("loaded") {
            <app-linked-control-row #controlTemplates />
            <app-cerrix-linked-item-table
                data-uuid="asset-linked-controls"
                [title]="'linkedItems.controls.controlsTitle' | t: {} : translationScope"
                [items]="controlsState.items"
                [templates]="controlTemplates"
                [loadDetails]="loadControlDetails"
                [canLink]="canLinkControls"
                [unlinkConfirmation]="{
                    title: 'linkedItems.controls.unlinkDialogTitle' | t,
                    description: 'linkedItems.controls.unlinkDialogDescription' | t
                }"
                (linkItems)="onLinkControls(controlsState.items)"
                (openItem)="onOpenLinkedControl($event)"
                (unlinkItem)="onUnlinkControl($event)"
            />
        }
    }
}
<app-cerrix-link-items-dialog
    [name]="linkDialogName"
    [title]="'linkedItems.risks.linkDialogTitle' | t"
    [items]="linkableItems()"
    [selectedIds]="linkedRiskIds()"
    (confirmed)="onConfirmLinkRisks($event)"
    (itemDetailsRequested)="onOpenLinkableRisk($event)"
/>
<app-cerrix-link-items-dialog
    [name]="controlLinkDialogName"
    [title]="'linkedItems.controls.linkDialogTitle' | t"
    [items]="linkableControlItems()"
    [selectedIds]="linkedControlIds()"
    (confirmed)="onConfirmLinkControls($event)"
    (itemDetailsRequested)="onOpenLinkableControl($event)"
/>
